import { Form, Select } from 'antd';
import AppFormEmailTag from '../AppFormEmailTag';
import { useRBAC } from '../../../../core/hooks/useRBAC';
import { CAN_MODIFY_DATASTORE_SETTINGS } from '../../../../core/PermissionRoles';

interface AppEmailsNotificationProps {
    readonly label: string;
    readonly testId?: string;
    readonly emailsList: string[] | undefined;
    readonly saveEmailNotifications: Function;
}

const AppEmailsNotification = ({
    label,
    testId = 'AppEmailsNotification',
    emailsList,
    saveEmailNotifications,
}: AppEmailsNotificationProps) => {
    const { hasPermission } = useRBAC();

    return (
        <Form.Item
            label={label}
            name="notificationRecipients"
            data-testid={testId}
            rules={[
                () => ({
                    validator(_, value) {
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        const isValidEmail = value.every((email: string) => {
                            return emailRegex.test(email);
                        });
                        if (!isValidEmail) {
                            return Promise.reject(
                                new Error(
                                    'All entries must be valid email addresses'
                                )
                            );
                        }
                        return Promise.resolve();
                    },
                }),
            ]}
            wrapperCol={{ span: 24 }}
            extra={
                'Use semicolon (;) to separate email addresses, remove all addresses to disable'
            }
        >
            <Select
                mode="tags"
                open={false}
                placeholder="Enter recipient's email address"
                showSearch={false}
                tagRender={(props: any) => <AppFormEmailTag {...props} />}
                value={emailsList}
                tokenSeparators={[';']}
                disabled={!hasPermission(CAN_MODIFY_DATASTORE_SETTINGS)}
                maxTagCount={5}
                onChange={(value: string[]) => saveEmailNotifications(value)}
            />
        </Form.Item>
    );
};

export default AppEmailsNotification;
